import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    gridColumn: '1/3',
  },
  captionWithIcon: {
    display: 'flex',
    gap: theme.spacing(2),
  },
}));

export default useStyles;
